import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import FacturesLivreurs from '@/features/factures-livreurs'

export const Route = createFileRoute('/_authenticated/factures-livraison/')({
  component: FacturesLivreurs,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Factures livraison`,
      },
    ],
  }),
})
